import React from 'react'
import Link from 'gatsby-link'
import { Helmet } from "react-helmet";

import Block from '../components/block';
import Title from '../components/my-title';

import BlockCover from '../components/block-cover';
import ContactImage from '../assets/contact.jpg';

import { Col, Button, Form, FormGroup, Label, Input, FormText, InputGroup, InputGroupAddon } from 'reactstrap';

const Contact = () => (
  <div>
    <Helmet>
      <title>Ébeniste, menuisier en île de france, Paris</title>
      <meta name="description" content="Découvrons ensemble les meilleurs solutions pour vos aménagements sur mesure intérieurs et extérieurs." />
    </Helmet>
    <BlockCover
      backgroundUrl={ContactImage}
      title="Contact"
      repeatedTitle={true} />

    <div className="decoration">
      <div className="row no-gutters">
        <div className="col-md-6 contact-background">
          <Block>
            <div className="row justify-content-center">
              <div className="col-md-7">
                <Title>Contactez-nous</Title>

                <Form method="post" data-netlify="true" data-netlify-honeypot="bot-field" name="contact">
                  <input type="hidden" name="form-name" value="contact" />
                  <p className="hidden">
                    <label>Don’t fill this out: <input name="bot-field" /></label>
                  </p>

                  <FormGroup>
                    <Input type="select" defaultValue="" name="type" id="type">
                      <option disabled value="">Vous êtes…</option>
                      <option value="monsieur">Monsieur</option>
                      <option value="madame">Madame</option>
                    </Input>
                  </FormGroup>
                  <FormGroup>
                    <Input type="text" name="name" id="name" placeholder="Nom, prénom" />
                  </FormGroup>
                  <FormGroup>
                    <Input type="email" name="email" id="email" placeholder="Adresse email" />
                  </FormGroup>
                  <FormGroup>
                    <Input type="textarea" rows="4" name="message" id="message" placeholder="Votre message" />
                  </FormGroup>
                  <div className="text-align-center">
                    <button type="submit" className="btn btn-primary btn-big btn-min-width-300 mt-3">
                      Envoyer
                    </button>
                  </div>
                </Form>
              </div>
            </div>
          </Block>
        </div>

        <div className="col-md-6 justify-content-center">
          <div className="bg-white contact-item-container">
            <div className="row">
              <div className="col-lg-6">
                <div className="contact-item">
                  <p className="mb-0 fs-27 color-red light lh-32">Didier <strong>Bré</strong></p>
                  <p className="fs-15 color-red bold uppercase lh-19" style={{
                    letterSpacing: '2px'
                  }}>Showroom</p>
                  <p className="fs-16 lh-23">17 Avenue d'Argenteuil<br />92600 Asnières-sur-Seine</p>
                  <p className="fs-16 lh-23 light">
                    Horaires sur rendez-vous : <br />
                    de 9h00 à 12h00 <br />
                    de 14h00 à 18h00
                  </p>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="contact-item">
                  <p className="mb-0 fs-27 color-red light lh-32">Didier <strong>Bré</strong></p>
                  <p className="fs-15 color-red bold uppercase lh-19" style={{
                    letterSpacing: '2px'
                  }}>Atelier de fabrication</p>
                  <p className="fs-16 lh-23">1 bis, av. du Capitaine Thuilleaux <br />78170 La-Celle-Saint-Cloud</p>
                  <p className="fs-16 lh-23 light">
                    Téléphone : 06 07 67 36 16 <br />
                    Fax : 01 40 80 08 43<br />
                     contact@menuiseriebre.fr
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="map-container embed-responsive">
            <iframe className="embed-responsive-item" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d655.5599366009526!2d2.2850217594424143!3d48.91082436660609!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e66f63a223d18b%3A0x935be1d3a0b639c5!2s17+Avenue+d&#39;Argenteuil%2C+92600+Asni%C3%A8res-sur-Seine!5e0!3m2!1sen!2sfr!4v1511172999944" width="800" height="600" frameBorder="0" style={{
              border: 0
            }} allowFullScreen></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default Contact



// WEBPACK FOOTER //
// ./src/pages/contact.js